import { routesTranslations } from "@/projectRoot/routes.config";

export function translationsHandler(params: 
    {
        refinedSlugs: Record<string, string>, 
        pathname: string, 
        lang: string, 
        route_parameter: string, 
        params: Record<string, string> 
    }
) {
    let path = Object.keys(params.params).length > 2 ? params.pathname.replace(`/${params.lang}`, '') : params.pathname.split('/')[params.lang == process.env.NEXT_PUBLIC_DEFAULT_LANG ? 1 : 2];
    let foundObj = Object.keys(routesTranslations).find(key => params.route_parameter ? key == params.route_parameter : Object.values(routesTranslations[key]).find(value => value == `/${path}${params.params.hasOwnProperty('id') ? '/:id' : ''}`));
    let slugs = Object.entries(routesTranslations).find(([key]) => key == foundObj)[1];
    let refinedSlugs = params.refinedSlugs;
    // dodat lang ispred :id zbog promene na routeUrl funkciji (ako ima multilangslugs onda se radi konkatenacija sa lang-om!!!)
    if(slugs){
        refinedSlugs = Object.fromEntries(
            Object.entries(slugs).map(([lang, path]) => [lang, (lang !== process.env.NEXT_PUBLIC_DEFAULT_LANG ? lang : '') + replaceParams(path, params.params)])
        );
    }
    return refinedSlugs;
}

export const replaceParams = (path: string, params: Record<string, string>) => {
    let refactoredPath = path;
    Object.keys(params).forEach(key => {
        if(key != 'locale'){
            refactoredPath = refactoredPath.replace(`:${key}`, params[key]);
        }
    });

    return refactoredPath;
}